import { AuthRoutes } from 'features/auth/routes';
import { paths, ROOT_PATHS } from './paths';
import { PublicProfile } from 'features/companies';

export const publicRoutes = [
  {
    path: `${ROOT_PATHS.AUTH}/*`,
    element: <AuthRoutes />,
  },
  // {
  //   path: `${paths.public.companyPublicProfile}`,
  //   element: <PublicProfile />,
  // },
];
